
import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import RightBtn from '../rightBtn/rightBtn';
import DocumentMeta from 'react-document-meta';
require('./wechat.scss')
require('./mobile_wechat.scss')

import { Get, wrapResponse } from './../../requst'

export default class WeChat extends React.Component {
    static async getInitialProps(ctx) {
        const [data, seo, caseRes, news] = await Promise.all([
            wrapResponse(Get({ url: 'weixin/banner' })),
            wrapResponse(Get({ url: 'weixin/seo' })),
            wrapResponse(Get({ url: 'weixin/case' })),
            wrapResponse(Get({ url: 'weixin/news' })),
        ])

        const footerProps = await Footer.getInitialProps()

        return { data, seo, case: caseRes, news, footerProps }
    }

    constructor(props, context) {
        super(props, context)
        this.state = {

        }

    }
    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    case() {
        return this.props.case.map((item, index) => (
            <a href={`/casedetails/${item.id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index} >
                <img className="Img" style={{ width: '100%' }} src={item.thumb} alt="" />
                <div className="TextBox" style={{ textAlign: 'center' }}>
                    <p>{item.title}</p>
                    {/*<p>{item.desc.substring(0,40)}</p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
            </a>
        ))
    }
    news() {
        return this.props.news.map((item, index) => (
            <li href={`/details/${item.id}`} key={index}>
                <div className="ImgBox">
                    <img className="Img" src={item.thumb} alt="" />
                </div>
                <p className="P_Con P_Head">{item.title}</p>
                <p className="P_Con P_Text">{item.desc}</p>
                <div className="Mask_DeatilsBtm"></div>
                <div className="Triangle"></div>
                <div className="MaskText">
                    <p>{item.created_at.substring(0, 7)}</p>
                    <p>{item.created_at.substring(8, 10)}</p>
                    <img src={require('../../assets/common/images/anniujiantou-bai.png')} alt="" />
                </div>
            </li>
        ))
    }
    render() {
        // console.log(document.body.offsetWidth)
        if (this.state.offsetWidth >= 1200) {

            if (this.props.seo) {
                const meta = {
                    title: this.props.seo.title,
                    description: this.props.seo.description,
                    // link: {
                    //   rel: {
                    //     canonical: 'http://example.com/path/to/sub-page'
                    //   }
                    // },
                    meta: {
                        charSet: 'utf-8',
                        name: {
                            keywords: this.props.seo.keywords
                        },
                    },
                    extend: true
                };
                return (
                    <DocumentMeta {...meta}>
                        <div>
                            <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                                <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                            </div>
                            <div className="Wechat_Middle_one">
                                <div className="ContainerBox">
                                    <p className="Title">我们能<span>做什么</span></p>
                                    <p className="SubTitle">每个行业我们都有成熟的基于微信生态的解决方案</p>
                                    <ul className="Content">
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/O2Odianshang.png')} alt="" /></div>
                                            <p className="TextTitle">O2O电商</p>
                                            <p className="Text">线上运营、线下消费、手机直接管理订单</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/diancanxitong.png')} alt="" /></div>
                                            <p className="TextTitle">点餐系统</p>
                                            <p className="Text">扫码点餐、自动打印小票、自动对应餐桌、支持多点经营</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/yingxiaogongju.png')} alt="" /></div>
                                            <p className="TextTitle">营销工具</p>
                                            <p className="Text">秒杀、拼团、集集乐多种玩法。助理营销</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/meishiwaimai.png')} alt="" /></div>
                                            <p className="TextTitle">美食外卖</p>
                                            <p className="Text">轻松管理外卖订单，提升餐厅营业收入</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/zhihuimendian.png')} alt="" /></div>
                                            <p className="TextTitle">智慧门店</p>
                                            <p className="Text">WiFi、当面付、会员卡等打造智慧门店</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/yuyuexitong.png')} alt="" /></div>
                                            <p className="TextTitle">预约系统</p>
                                            <p className="Text">预定系统、预定酒店等预约服务，合理分配门店资源</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/fuwuxitong.png')} alt="" /></div>
                                            <p className="TextTitle">服务系统</p>
                                            <p className="Text">扫码开门、扫码开储物柜、扫码淋雨、购买私教、约课，教练独立后台</p>
                                        </li>
                                        <li>
                                            <div className="Image"><img src={require('../../assets/common/images/shipinxitong.png')} alt="" /></div>
                                            <p className="TextTitle">视频系统</p>
                                            <p className="Text">用户在线选购课程，在线答疑，老师实时回复</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="Wechat_Middle_two">
                                <div className="ContainerBox">
                                    <p className="Title">开发<span>类型</span></p>
                                    <p className="SubTitle">我们有成熟的小程序解决方案</p>
                                    <ul className="Content">
                                        <li>
                                            <div className="Left"><img src={require('../../assets/common/images/zhanshi.png')} alt="" /></div>
                                            <div className="Right">
                                                <p className="TextTitle">展示</p>
                                                <p className="TextCont">· 微网站（多种模式自由选择，一键建站轻松管理）</p>
                                                <p className="TextCont">·  LBS定位（定位，有效统计粉丝来源）</p>
                                                <p className="TextCont">· 图文推送（推送，图文并茂，免费发布，降低成本）</p>
                                                <p className="TextCont">· 微名片（快速生成时尚微名片，免费免注册）</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="Left"><img src={require('../../assets/common/images/tuiguang.png')} alt="" /></div>
                                            <div className="Right">
                                                <p className="TextTitle">推广</p>
                                                <p className="TextCont">· 抢红包（强效吸粉，引爆粉丝疯狂传播）</p>
                                                <p className="TextCont">· 摇一摇（红包，优惠，会议信息，摇一摇即得）</p>
                                                <p className="TextCont">· 互动墙（现场互动神奇，新潮互动体验方式）</p>
                                                <p className="TextCont">· 微打印（个性美照打印、二维码植入、品牌强势营销）</p>
                                                <p className="TextCont">· 微会员（注册会员享受会员特权，打造线上线下会员制度无缝对接。） </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="Left"><img src={require('../../assets/common/images/fuwu.png')} alt="" /></div>
                                            <div className="Right">
                                                <p className="TextTitle">服务</p>
                                                <p className="TextCont">· 微支付（主流支付方式，上架必备功能）微投票（收集消费评价，了解消费需求）</p>
                                                <p className="TextCont">· 微投票（收集消费评价，了解消费需求）</p>
                                                <p className="TextCont">· 微预约（用户自主预约服务，提高服务效率）</p>
                                                <p className="TextCont">· 进度查询（物流、服务进度快速查询，信息尽在掌握）</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="Left"><img src={require('../../assets/common/images/yingxiao.png')} alt="" /></div>
                                            <div className="Right">
                                                <p className="TextTitle">营销</p>
                                                <p className="TextCont">·微分销（一键开商城，快速发展微信分销渠道，销售网络遍布全国）</p>
                                                <p className="TextCont">·微商城（搭建商城平台，低成本大收益）</p>
                                                <p className="TextCont">·微店铺（在线购物解决方案，店铺服务、营销与销售一体化）</p>
                                                <p className="TextCont">·微团购（促进活动促销、拓展上架的品牌及销售）</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {this.props.case ? <div className="Wechat_Middle_three">
                                <p className="Title">微信开发<span>案例</span></p>
                                <ul className="Content">
                                    {this.case()}
                                </ul>
                                <a href='/caseshow?key=2' className="Button">
                                    更多
                                </a>
                            </div> : null}
                            <div className="Wechat_Process">
                                <div className="ContainerBox">
                                    <p className="Title">微信开发流程</p>
                                    <p className="SubTitle">每个行业我们都有成熟的小程序解决方案</p>
                                    <ul className="Content_One">
                                        <li>
                                            <img src={require('../../assets/common/images/qianqigoutong.png')} alt="" />
                                            <p className="Head">01前期沟通</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-you.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/xuqiupinggu.png')} alt="" />
                                            <p className="Head">02需求评估</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-you.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/chanpinsheji.png')} alt="" />
                                            <p className="Head">03产品设计</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-you.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/jishukaifa.png')} alt="" />
                                            <p className="Head">04技术开发</p>
                                        </li>
                                    </ul>
                                    <ul className="Content_Two">
                                        <li><img src={require('../../assets/common/images/jiantou-xia.png')} alt="" /></li>
                                    </ul>
                                    <ul className="Content_Three">
                                        <li>
                                            <img src={require('../../assets/common/images/jishutuoguan.png')} alt="" />
                                            <p className="Head">08技术托管</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-zuo.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/shouhoufuwu.png')} alt="" />
                                            <p className="Head">07售后服务</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-zuo.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/ceshi.png')} alt="" />
                                            <p className="Head">06测试</p>
                                        </li>
                                        <li><img src={require('../../assets/common/images/jiantou-zuo.png')} alt="" /></li>
                                        <li>
                                            <img src={require('../../assets/common/images/fabushangxian.png')} alt="" />
                                            <p className="Head">05发布上线</p>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="Wechat_Middle_four">
                                <p className="Title">微信开发<span>资讯</span></p>
                                <p className="SubTitle">强大功能，支撑您社交微信应用更多需求</p>
                                <ul className="Buttom">
                                    {this.props.news ? this.news() : null}
                                </ul>
                                <a href="/newscenter?key=2" className="button" >更多</a>
                            </div>
                            <Footer {...this.props.footerProps} />
                            <RightBtn props={this.props} />
                        </div>
                    </DocumentMeta>

                )
            } else {
                return null
            }
        } else {
            return (
                <div className="Mobile_Wechat">
                    <div className="Mobile_WechatBox">
                        <p className="Mobile_Title">我们能<span>做什么</span></p>
                        <p className="Mobile_SubTitle">每个行业我们都有成熟的基于微信生态的解决方案</p>
                        <div className="Mobile_ShowBox">
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/O2Odianshang@3x.png')} alt="" /></div>
                                <p className="Show_Head">O2O电商</p>
                                <p className="TextShow">线上运营、线下消费、手机直接管理订单</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/diancanxitong@3x.png')} alt="" /></div>
                                <p className="Show_Head">点餐系统</p>
                                <p className="TextShow">扫码点餐、自动打印小票、自动对应餐桌、支持多点经营</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/yingxiaogongju@3x.png')} alt="" /></div>
                                <p className="Show_Head">营销工具</p>
                                <p className="TextShow">秒杀、拼团、集集乐导尿管多种玩法。助理营销</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/meishiwaimai@3x.png')} alt="" /></div>
                                <p className="Show_Head">美食外卖</p>
                                <p className="TextShow">轻松管理外卖订单，提升餐厅营业收入</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/zhihuimendian@3x.png')} alt="" /></div>
                                <p className="Show_Head">智慧门店</p>
                                <p className="TextShow">WiFi、当面付、会员卡等打造智慧门店</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/yuyuexitong@3x.png')} alt="" /></div>
                                <p className="Show_Head">预约系统</p>
                                <p className="TextShow">预定系统、预定酒店等预约服务，合理分配门店资源</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/fuwuxitong@3x.png')} alt="" /></div>
                                <p className="Show_Head">服务系统</p>
                                <p className="TextShow">扫码开门、扫码开储物柜、扫码淋雨、购买私教、约课，教练独立后台</p>
                            </div>
                            <div className="Mobile_Show">
                                <div className="Round"><img src={require('../../assets/common/images/shipinxitong@3x.png')} alt="" /></div>
                                <p className="Show_Head">视频系统</p>
                                <p className="TextShow">用户在线选购课程，在线答疑，老师实时回复</p>
                            </div>
                        </div>
                    </div>
                    <div className="Mobile_WechatPro">
                        <p className="Mobile_Title">微信开发流程</p>
                        <p className="Mobile_SubTitle">每个行业我们都有成熟的小程序解决方案</p>
                    </div>
                    <div className="Mobile_Case">
                        <p className="Mobile_Title">开发案例</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                            </tbody>
                        </table>
                        <button></button>
                    </div>                                                                                                                                                                                                                        11
                </div>
            )
        }

    }
}